<template>
  <div class="notification-verify-email">
    <div class="heading">
      <div class="heading-6">Verify your email address</div>
      <button type="button" class="close-button" aria-label="Close" @click="close">
        <close-icon></close-icon>
      </button>
    </div>
    <verify-email-content @resent="close" @enter-code="close"></verify-email-content>
  </div>
</template>

<script>
import CloseIcon from 'vue-material-design-icons/Close';
import {mapGetters} from 'vuex';

import VerifyEmailContent from '@/components/common/VerifyEmailContent';

export default {
  watch: {
    userIsLoggedInState(value) {
      if (!value) {
        this.$emit('close');
      }
    },
    userEmailVerifiedState(value) {
      if (value) {
        this.close();
      }
    },
  },
  computed: {
    ...mapGetters(['userIsLoggedInState', 'userEmailVerifiedState']),
  },
  methods: {
    close() {
      const sixHours = 21600000;
      this.$store.commit('setNextVerifyNotificationTimeState', new Date().getTime() + sixHours);
      this.$emit('close');
    },
  },
  components: {CloseIcon, VerifyEmailContent},
  name: 'NotificationVerifyEmail',
};
</script>

<style scoped lang="scss">
@use '@common/style/variables' as *;

.notification-verify-email {
  padding: 16px;

  .heading {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .close-icon {
      color: $neutral-400;
    }
  }

  .close-button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    border: 0;
    background: transparent;
    cursor: pointer;
  }
  @media only screen and (min-width: $breakpoint-phablet) {
    max-width: 360px;
  }
}
</style>
